import PropTypes from 'prop-types';
import React from 'react';
import BarberAvatar from '../../components/BarberAvatar';
import Icon, { GLYPHS } from '../../../../common/icon';
import Date from '../../../../common/date';
import ChairRentalAmount from './ChairRentalAmount';
import { chairRentalShape } from '../shapes';
import ChairRentalModal from '../containers/ChairRentalModal';

const ChairRentalListItem = ({
  chairRental,
  modalOn,
  modalOff,
  modalIsOn,
  toggleEnabled,
}) => (
  <React.Fragment>
    <div className="c-table-card__row u-cursor-pointer" onClick={modalOn}>
      <div className="c-table-card__cell u-1/12">
        <div className="c-switch u-inline-block u-align-middle" onClick={toggleEnabled}>
          <input
            id={`chair-rental-enabled-${chairRental.barberId}`}
            className="c-switch__toggle"
            type="checkbox"
            checked={chairRental.enabled}
            readOnly
          />
          <label className="c-switch__label" htmlFor={`chair-rental-enabled-${chairRental.barberId}`} />
        </div>
      </div>
      <div className="c-table-card__cell u-3/12">
        <div className="u-text-trim">
          <span className="c-avatar u-mr">
            <BarberAvatar barber={chairRental.barber} />
          </span>
          <span className="c-chair-rental-data c-chair-rental-data--green u-mr--">
            {chairRental.barber.firstName} {chairRental.barber.lastName}
          </span>
        </div>
      </div>
      <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/12">
        <ChairRentalAmount color="red" amount={chairRental.overdueAmount} />
      </div>
      <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/12">
        <ChairRentalAmount
          color="green"
          amount={chairRental.nextPaymentAmount}
          showSuffix
        />
      </div>
      <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/12">
        <ChairRentalAmount color="green" amount={chairRental.totalDueAmount} />
      </div>
      <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/12">
        <div className="c-chair-rental-data">
          <Date>{chairRental.dueDate}</Date>
        </div>
      </div>
      <div className="c-table-card__cell u-1/12 u-text-right">
        <Icon glyph={GLYPHS.arrowRightGreen} size="tiny" />
      </div>
    </div>
    <ChairRentalModal
      display-if={modalIsOn}
      close={modalOff}
      chairRental={chairRental}
    />
  </React.Fragment>
);

ChairRentalListItem.propTypes = {
  chairRental: chairRentalShape.isRequired,
  modalIsOn: PropTypes.bool.isRequired,
  modalOn: PropTypes.func.isRequired,
  modalOff: PropTypes.func.isRequired,
  toggleEnabled: PropTypes.func.isRequired,
};

export default ChairRentalListItem;
